export default function reducer(
  state = {
    data: null
  },
  action: {
    type: string;
    payload: {
      email: string;
      first_name: string;
      last_name: string;
      customer_id: number;
    };
  }
) {
  switch (action.type) {
    case 'GET_CUSTOMER_USERS_STARTED': {
      return { ...state, changingStatus: 'ongoing' };
    }
    case 'GET_CUSTOMER_USERS_SUCCESS': {
      return {
        ...state,
        changingStatus: 'success',
        data: action.payload
      };
    }
    case 'GET_CUSTOMER_USERS_FAILED': {
      return { ...state, changingStatus: 'failed', data: action.payload };
    }
    case 'GET_CUSTOMER_USERS_NET_FAILED': {
      return {
        ...state,
        changingStatus: 'netFailed',
        data: action.payload
      };
    }
    // take for a test spin?
    case 'GET_CUSTOMER_USERS_USER': {
      return {
        ...state,
        changingStatus: ''
      };
    }
    default: {
      return state;
    }
  }
}
